/**
 * Calculates the radius in miles from bounds and center coordinates.
 * Uses the Haversine formula to find the maximum distance from center to any corner of the bounds.
 */
export function getRadiusFromBounds(
  centerLat: number,
  centerLng: number,
  bounds: {
    southwest: { lat: number; lng: number };
    northeast: { lat: number; lng: number };
  },
): number {
  const EARTH_RADIUS_MILES = 3959;

  const corners = [
    { lat: bounds.southwest.lat, lng: bounds.southwest.lng },
    { lat: bounds.southwest.lat, lng: bounds.northeast.lng },
    { lat: bounds.northeast.lat, lng: bounds.southwest.lng },
    { lat: bounds.northeast.lat, lng: bounds.northeast.lng },
  ];

  const distances = corners.map((corner) => {
    const dLat = ((corner.lat - centerLat) * Math.PI) / 180;
    const dLng = ((corner.lng - centerLng) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((centerLat * Math.PI) / 180) *
        Math.cos((corner.lat * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return EARTH_RADIUS_MILES * c;
  });

  return Math.max(...distances);
}
